import { API_HOST, BRAND_NAME, toApolloClient } from '@pm/core';

export const apolloClient = toApolloClient({
  apiHost: API_HOST,
  brand: BRAND_NAME.Frida,
});
